<ng-container *ngIf="inPreviewMode">
  <button pButton type="button" [label]="'Exit Preview Mode'" (click)="exitPreview(event$)"></button>
</ng-container>

